import { withAuthHeaders } from "./auth";

const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
const api = (path) => `${BASE}/${String(path).replace(/^\/+/, "")}`;

export const fetchDoctorNotesByAppointment = async (apptId, userID) => {
    const response = await fetch(
        api(`/api/doctor-notes/${apptId}?userID=${userID}`),
        { headers: withAuthHeaders() }
    );
    if (!response.ok) {
        throw new Error("Failed to fetch doctor notes");
    }
    return response.json();
}

export const updateDoctorNotesByAppointment = async (apptId, noteData) => {
    const checkResponse = await fetch(
        api(`/api/doctor-notes/${apptId}?userID=${noteData.userID}`),
        { headers: withAuthHeaders() }
    );
    if (!checkResponse.ok) {
        // If the notes do not exist, we can create them
        const createResponse = await fetch(api(`/api/doctor-notes/${apptId}`),
            {
                method: "POST",
                headers: withAuthHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(noteData)
            }
        );
        if (!createResponse.ok) {
            throw new Error("Failed to create doctor notes");
        }
        return createResponse.json();
    }
    const response = await fetch(
        api(`/api/doctor-notes/${apptId}`),
        {
            method: "PATCH",
            headers: withAuthHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify(noteData)
        }
    );
    if(!response.ok) {
        throw new Error("Failed to update doctor notes");
    }
    return response.json();
}